<template>
  <NuxtLayout
    :is-menu-hidden="page?.is_menu_hidden"
    :is-footer-hidden="page?.is_footer_hidden"
    should-add-margin-top-into-main-content
  >
    <div class="slug">
      <Widgets v-if="page?.widgets" :widgets="page?.widgets" />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { flatten, emptyToUndefined } from '@/utils'

const { locale } = useI18n()
const route = useRoute()
const slug = flatten(route.params.slug)
const category = emptyToUndefined(flatten(route.params.category))

const { data: page, error } = await useAsyncData('pageSlug', () =>
  useApi().publicPagesSimplePagesRetrieve(slug)
)

if (error.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
}

const expectedCategory = emptyToUndefined(
  // @ts-ignore
  page.value?.[`category_${locale.value}`] as string | null | undefined
)

if (expectedCategory !== category) {
  const redirectRoute: {
    name: string
    params: { category: string; slug: string } | { slug: string }
  } = expectedCategory
    ? { name: 'category-slug', params: { category: expectedCategory, slug } }
    : { name: 'slug', params: { slug } }

  await navigateTo(useLocalePath()(redirectRoute), { redirectCode: 301 })
}

const setI18nParams = useSetI18nParams()
setI18nParams({
  'pl-en': {
    slug: page.value?.slug_en,
    ...(expectedCategory && { category: expectedCategory })
  },
  'pl-pl': {
    slug: page.value?.slug_pl,
    ...(expectedCategory && { category: expectedCategory })
  }
})

const { meta } = usePrepareSEOHead(page)

useHead({
  title: page.value?.title,
  meta
})
</script>
